<template>
  <div class="sending-payment">
    <div class="main-container">
      <div class="center small-12">
        <loading-element inline class="loading-icon"></loading-element>
        <h2> {{ strings.title }} </h2>
        <h6> {{ strings.description }} </h6>
      </div>
    </div>
  </div>
</template>

<script>
// Strings
import descriptions from '../../i18n/en/strings';

export default {
  name: 'SendingPayment',
  data() {
    return {
      strings: descriptions.loadingProcessingPayment
    }
  }
}
</script>

<style lang="scss" type="scss" scoped>
@import '~@/styles/variables.scss';

.sending-payment {
  color: $black;
  max-width: $sfi-max-form-width-sm-min;
  margin: 80px auto;
  position: relative;

  .loading-icon {
    margin-bottom: 40px;
  }

  @include breakpoint (small only) {
    .main-container {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  h2 {
    padding-bottom: 20px;
  }

  h6 {
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SendingPayment.vue